import { initPerformanceAnalytics } from '@stitch-fix/sf-next';
import { getWindow } from '@stitch-fix/mode-react';
import { initDatadogLogger } from './utils/loggers/browser';
import { FIX_CHECKOUT_ORDER_RESUME_ROUTE, MY_ITEMS_ORDERS_RESUME_ROUTE } from './features/androidPaymentReturn/constants';

/**
 * Stripe appends the PaymentIntent's client secret to these return URLs.
 * Datadog RUM/Logs capture the full page URL by default at init time — before
 * any page-level code can run — so browser telemetry must not initialize on
 * these paths at all, or the secret reaches Datadog.
 */
const TELEMETRY_EXCLUDED_PATHS: string[] = [FIX_CHECKOUT_ORDER_RESUME_ROUTE.appPath, MY_ITEMS_ORDERS_RESUME_ROUTE.appPath];
const win = getWindow();
const isTelemetryExcludedPath = Boolean(win && TELEMETRY_EXCLUDED_PATHS.includes(win.location.pathname));
if (!isTelemetryExcludedPath) {
  initDatadogLogger();
  initPerformanceAnalytics({
    sampleRate: 100
  });
}